import { useCartContext } from 'state/cart';

import { useCheckoutState } from './use-checkout-state';

export const useCheckoutLoadingState = () => {
  const {
    isSubmittingOrder,
    isBuildingCommitOrderPayload,
    isLoadingPaymentMethods,
  } = useCheckoutState();
  const { isOrderPriceLoading } = useCartContext();

  return {
    isOrderPriceLoading,
    isSubmittingOrder,
    isBuildingCommitOrderPayload,
    isLoadingPaymentMethods,
    isCheckoutLoading:
      isOrderPriceLoading ||
      isSubmittingOrder ||
      isBuildingCommitOrderPayload ||
      isLoadingPaymentMethods,
  };
};
